var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{staticClass:"base-checkbox",style:({
    transform: `scale(${_vm.zoomValue}) ${_vm.zoomValue > 1 ? 'translateY(calc((' + _vm.zoomValue + ' - 1) * 2rem))' : ''}`,
  }),attrs:{"disabled":_vm.disabled,"checked":_vm.value,"indeterminate":_vm.indeterminate,"id":_vm.id},on:{"change":_vm.onCheckboxClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }